import { NgbdSortableHeader } from './sortable.directive';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [

	],
	declarations: [
        NgbdSortableHeader
	],
	exports: [
        NgbdSortableHeader
	]
})
export class SortableModule { }

